export var getCurrentPriceColor = function getCurrentPriceColor(theme, oldPriceVisible) {
  return oldPriceVisible ? theme.palette.offer.main : theme.palette.text.primary;
};
//# sourceMappingURL=getCurrentPriceColor.js.map